import { StyleProp, ViewStyle } from 'react-native';
import { View } from '@shared/components/View';
import { FileUpload } from '@shared/components/blocks/types';
import { FileList } from './file/FileList';
import { ImageList } from './image/ImageList';

interface FilesProps {
  files: FileUpload[];
  style?: StyleProp<ViewStyle>;
  editable: boolean;
  onRemoved?(file: FileUpload): void;
  compactFileView: boolean;
  maxHeight?: number;
  maxWidth?: number;
  minWidth?: number;
  verticalPadding?: number;
  horizontalPadding?: number;
  numImagesToShow?: number;
}

export function InputBlockMedia({
  files,
  style,
  onRemoved,
  editable,
  maxHeight = 200,
  maxWidth = 300,
  minWidth,
  horizontalPadding = 1,
  verticalPadding = 1,
  numImagesToShow,
  compactFileView,
}: FilesProps) {
  return (
    <View flex paddingVertical={verticalPadding} paddingHorizontal={horizontalPadding}>
      <ImageList
        files={files}
        style={style}
        onRemoved={onRemoved}
        editable={editable}
        maxHeight={maxHeight}
        maxWidth={maxWidth}
        minWidth={minWidth}
        numImagesToShow={numImagesToShow}
      />
      <FileList
        files={files}
        onRemoved={onRemoved}
        compactFileView={compactFileView}
        editable={editable}
      />
    </View>
  );
}
